import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';

import { RoutingService } from '@shared/services/routing.service';
import { DebugHelper } from '@shared/helpers/debug.helper';

import { ForgotPasswordActions } from '../store/forgot-password.actions';

export const forgotPasswordTokenGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  const router = inject(Router);

  const token: string = route.params['forgotPasswordToken'];

  if (!token) {
    return router.createUrlTree([RoutingService.LOGIN]);
  }

  store.dispatch(new ForgotPasswordActions.SetToken(token))
       .subscribe({
         error: (error) => {
           DebugHelper.log(
               'ForgotPasswordTokenGuard: Error setting token',
               error,
           );
         },
       });
  return router.createUrlTree([RoutingService.FORGOT_PASSWORD_NEW_PASSWORD]);
};
